import {Component, inject, OnInit} from '@angular/core';
import {ActivatedRoute, RouterOutlet} from '@angular/router';
import {takeUntil} from 'rxjs';
import {AuthenticatedBaseComponent} from '../../authenticated-base.component';
import {TabSwitcherComponent} from '../../../components/tab-switcher/tab-switcher.component';
import {TabSwitcherConfig} from '../../../components/tab-switcher/tab-switcher-configuration.interface';
import {BackButtonComponent} from '../../../components/back-button/back-button.component';
import {ServiceProviderHub} from '@generated-backend-types';
import Event = ServiceProviderHub.App.Http.Resources.ServiceProviderHub.Eventmanagement.Event.Event;

@Component({
  selector: 'app-event-detail-shell',
  templateUrl: './event-detail-shell.component.html',
  imports: [RouterOutlet, TabSwitcherComponent, BackButtonComponent],
  standalone: true,
})
export class EventDetailShellComponent extends AuthenticatedBaseComponent implements OnInit {
  public event?: Event;
  private activatedRoute = inject(ActivatedRoute);

  public get tabConfig(): TabSwitcherConfig[] {
    if (!this.event) return [];
    const base = `/events/${this.event.id}`;
    return [
      {link: `${base}/details`, translationKey: 'events.detail.tabs.details', exact: false},
      {link: `${base}/inquiries`, translationKey: 'events.detail.tabs.inquiries', exact: false},
      {link: `${base}/event-overview-snapshots`, translationKey: 'events.detail.tabs.event_overview_snapshots', exact: false},
      {link: `${base}/procedure`, translationKey: 'events.detail.tabs.procedure', exact: false},
      {link: `${base}/timetable`, translationKey: 'events.detail.tabs.timetable', exact: false},
    ];
  }

  public ngOnInit(): void {
    this.titleService.setTitle('events.detail.title');
    this.activatedRoute.data.pipe(takeUntil(this.onDestroy$)).subscribe(data => {
      this.event = data['event'];
      this.cdr.markForCheck();
    });
  }

  public override ngAfterViewInit(): void {
    this.contentHeaderService.setContentHeaderFallback(this.contentHeaderTemplate);
  }
}
